export default __webpack_public_path__ + "2c51273c62121c73de7bd94e3ca1790f.png";